import { memo, useState } from "react";
import PropTypes from "prop-types";
import { Button, Checkbox, ListItemText, Menu, MenuItem } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";

const ColumnsVisibilityMenu = ({ columns, hiddenColumns, onToggleColumn }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <Button
        variant="outlined"
        color="inherit"
        size="small"
        startIcon={<SettingsIcon fontSize="small" />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{ borderColor: "grey.400", color: "text.primary" }}
      >
        Columns
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ sx: { maxHeight: 320 } }}
      >
        {columns.map(({ key, label }) => (
          <MenuItem key={key} onClick={() => onToggleColumn(key)} dense>
            <Checkbox
              size="small"
              checked={!hiddenColumns.has(key)}
              disableRipple
            />
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

ColumnsVisibilityMenu.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, label: PropTypes.string }),
  ).isRequired,
  hiddenColumns: PropTypes.instanceOf(Set).isRequired,
  onToggleColumn: PropTypes.func.isRequired,
};

export default memo(ColumnsVisibilityMenu);
